import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ApplicationService } from "app/services/application.service";
import { CarrierService } from "app/services/carrier.service";
import { DocumentsServiceService } from "app/services/documents-service.service";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { environment } from "environments/environment";
import { AnnualComplianceService } from "../service/annual-compliance.service";
import { PermitService } from "app/services/permit.service";
import { CorspdcService } from "app/services/corspdc.service";
import { Observable, forkJoin } from "rxjs";
import { map } from "rxjs/operators";
import { AuthWebService } from "app/services/authweb.service";
import { FormBuilder } from "@angular/forms";
import { CountryService } from "app/services/country.service";
import { SharedModule } from 'app/shared.module';
import {StepperContainerComponent} from '../../shared/stepper/stepper-container/stepper-container.component';
import { PermitTypeDocumentService } from "app/services/permit-type-document.service";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-compliancedocument',
  templateUrl: './compliancedocument.component.html',
  styleUrls: ['./compliancedocument.component.scss']
})
export class CompliancedocumentComponent implements OnInit {
  selectedPermits = [];
  count: number;
  ids: string;
  pageNumber: number = 1;
  currentId: number;
  complianceIds: any=[];
  currentPermitDetails: any = [];
  uploadedDocs: any;
  permitDocumentsLink: any = [];
  @ViewChild("content") modal: NgbModal;
  isLoading: boolean = false;
  allDocs = [];
  message = "Loading Documents...";
  removeRef: any;
  pdfSrc: any;
  img: any;
  carrierId: any;
  accountBalance: any;
  complianceDetails: any;
  documentPayload = [];
  carrierDetails: any = [];
  compliantStatuses: any;
  user: any = {};
  countryName: any;
  countries:any = [];
  permit_id: number;
  isViewMode: boolean = false;
  isLoadingImg: boolean = false;
  isChecked: boolean = true;
  
  @Output() prevNext = new EventEmitter();

    // Step 2 Variables
    complianceVehicleDetails: any = [];
    permitPaymentDetails: any = [];
    feeToBePaid: number;
  
    //Varibles to Manage Stepper
    background1 = "var(--sapphire)";
    background2 = "var(--background)";
    background3 = "var(--background)";
  
    isProgress1 = true;
    isProgress2 = false;
    isProgress3 = false;
  
    isStepper1 = true;
    isStepper2 = false;
    isStepper3 = false;
    @Output() nextStepEmitter = new EventEmitter<number>();
    @Output() prevStepEmitter = new EventEmitter<number>();
    // PAYMENT FORM
    checkoutForm = this.formBuilder.group({
      PAY_REQUEST_ID: "",
      CHECKSUM: "",
    });
    payGateUrl: string = "https://secure.paygate.co.za/payweb3/process.trans";
    payReqId: string = "";
    checkSum: string = "";

    @ViewChild(StepperContainerComponent) StepperContainer;
  ShowAll: boolean = true;
  constructor(
    private formBuilder: FormBuilder,
    private authWebService: AuthWebService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _confirmDialogService: ConfirmDialogService,
    private _applicationService: ApplicationService,
    private _document: DocumentsServiceService,
    private _carrier: CarrierService,
    private confirmDialogService: ConfirmDialogService,
    private documentService: DocumentsServiceService,
    private toastService: ToastNotificationService,
    private _annualCompliance: AnnualComplianceService,
    private _location: Location,
    private sanitizer: DomSanitizer,
    private _permit: PermitService,
    private _correspondance: CorspdcService,
    private _country:CountryService,
    private _permitDocs: PermitTypeDocumentService
  ) {
    this.user = this.authWebService.userData
      ? this.authWebService.userData.User
      : null;
  }

  ngOnInit(): void {
    this.isLoading = true;
  this.ids = this.getIdFromUrl(window.location.href);
  this.complianceIds= Number(this.ids);
    this.getDetailsAndDocuments(this.pageNumber);
    this.isLoading = false;
  }
  getComplianceDetailsById() {
    this.isLoading = true;
    this._annualCompliance.getAnnualComplianceDetailsById(this.currentId).subscribe(
      (res: any) => {
        if (res) {
          this.currentPermitDetails = res;
          console.log("DocDetails", this.currentPermitDetails);
          this.carrierId = res.carrier_id;
          this.getComplianceDetailsByVIN();
          this.getPermitRelatedDocsByID();
          this.getCountries();
        }
        this.isLoading = false;

      },
      (err) => {
        this.isLoading = false;
        console.error(err);
      }
    );
  }
  


  getComplianceDetailsByVIN() {
    this.isLoading = true;
    const obj = {
      vin: this.currentPermitDetails.VN_num,
      company_regnumber: this.currentPermitDetails.company_registration,
    };
    this._annualCompliance.getComplianceStatuses(obj).subscribe(
      (res: any) => {
        if (res) {
          this.compliantStatuses = res;
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        this.isLoading = false;
        console.error(err);
      }
    );
  }

  /**
   * Method to get the Linked documents which can be uploaded for the permit
   */
  async getPermitRelatedDocsByID(): Promise<void> {
    this.isLoading = true;
    this._permitDocs.getLinkedAndUnlinkedDoctypes(this.currentPermitDetails.permit_type_id)
      .subscribe(
        (res: any) => {
          if (res && res.PermitLinked) {
            this.permitDocumentsLink = res.PermitLinked;
            this.getComlianceDocumentsById();
          }
          this.isLoading = false;
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
        }
      );
  }

  async getCountries() {
    try {
      this.isLoading = true;
      const result = await this._country.listAllCountries().toPromise();
      if (result) {
        this.countries = result;
        this.isLoading = false;
        this.countries.forEach((country) => {
          if (country.id == this.currentPermitDetails.carrier.country_id) {
            this.countryName = country.desc;
            console.log(this.countryName);
            return;
          }
        });
      }
    } catch (error) {
      this.isLoading = false;
    }
  }

  getPermitDocumentsById() {
    this.isLoading = true;
    this._document
      .getPermitById(this.currentPermitDetails.application_id)
      .subscribe((res: any) => {
        if (res) {
          this.uploadedDocs = res;
          this.patchDocs();
        }
      });
  }

  //Go back to the listing page
  cancel() {
    this.currentPermitDetails.carrier_id
      ? this._router.navigate([`/annual-compliance/list/${this.currentPermitDetails.carrier_id}`])
      : history.back();
  }

  patchDocs() {
    let newArr = [];
    this.permitDocumentsLink.forEach((element) => {
      const document_type_id = element.document_type_id;
      const foundEl: Array<any> = this.uploadedDocs.filter(
        (item) => item.document_type_id == document_type_id
      );
      if (foundEl && foundEl.length) {
        foundEl.forEach((el) => {
          newArr.push({
            document_type_id: document_type_id,
            fileName: el.file_name,
            id: el.id,
            document_link: el.document_link,
            date_created: el.date_created,
          });
        });
      }
    });
    this.allDocs = newArr.reduce((groups, item) => {
      const group = groups[item.document_type_id.toString()] || [];
      group.push(item);
      groups[item.document_type_id] = group;
      return groups;
    }, {});
    console.log("documents",this.allDocs)
  }
  async onClickSubmit(val) {
    let canUpload = true;
    let concatenatedMessage = "";
  
    switch (val) {
      case 2:
        if (this.documentPayload.length < 0) {
          return;
        } else {
          for (let x = 0; x < this.complianceIds.length; x++) {
            this.currentId = this.complianceIds[x];
             await this.getComplianceDetailsForDocuments();
  
            // Validate documents
            this.permitDocumentsLink.forEach(element => {
              const existsInArray2 = this.uploadedDocs.some(p => p.document_type_id === element.document_type_id);
  
              if (element.is_mandatory && !existsInArray2) {
                canUpload = false;
                concatenatedMessage += 'The document ' + element.description + ' is mandatory for page: ' + this.pageNumber + ". ";
              }
            });
  
            if (!canUpload) {
              this.toastService.error(concatenatedMessage, 'Documents');
              return; // Stop further processing if there are validation errors
            }
          }
        }
        break;
  
      case 3:
        this.nextStep();
        break;
    }
    
    if (canUpload) {
      this.useDocument();
      this.toastService.success('Successfully uploaded documents', 'Documents');
    }
  }
  
  useDocument() {
    this.isLoading = true;
    this._document.useThisDocument(this.documentPayload).subscribe(
      (res: any) => {
        if (res) {
          this.isLoading = false;
          this.hideStepOneFromBeingActive();
          this.stepTwoActiveTab();
          this.getComplianceVehicleDetails();
          this.getCarrierDetails();
          this.getPaymentInfo();
        }
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

    //Get Compliance Certificate Payment Screen Details

    getComplianceVehicleDetails() {
      this.isLoading = true;
      this._annualCompliance.getPermitVehicleDetails(this.currentPermitDetails.carrier_id).subscribe(
        (response) => {
          this.isLoading = false;
          this.complianceVehicleDetails = response;
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
        }
      );
    }
  
    //Get Payment Info of Compliance
    getPaymentInfo() {
      this.isLoading = true;
      this._permit.getPaymentInfoForAnnualCompliance(this.currentId).subscribe(
        (res: any) => {
          this.permitPaymentDetails = res;
          if (res.permit_type && res.permit_type.charge_when_ind) {
            this.feeToBePaid =
              res.permit_type.charge_when_ind == 2
                ? res.permit_type.current_application_fee +
                  res.permit_type.current_fee
                : res.permit_type.current_application_fee;
          }
          this.isLoading = false;
        },
        (err) => {
          console.error(err);
          this.isLoading = false;
        }
      );
    }

   // ------------Methods to Manage Stepper----------------------//
   jumpToDoc() {
    this.stepOneActiveTab();
    this.hideStepTwoFromBeingActive();
    this.hideStepThreeFromBeingActive();
  }

  stepOneActiveTab() {
    const stepOne = <HTMLElement>document.getElementsByClassName("step-one")[0];
    stepOne.style.fontSize = "20px";
    stepOne.style.fontWeight = "bold";
  }

  stepTwoActiveTab() {
    this.nextStep();
  }

  stepThreeActiveTab() {
    const stepTwo = <HTMLElement>(
      document.getElementsByClassName("step-three")[0]
    );
    stepTwo.style.fontSize = "20px";
    stepTwo.style.fontWeight = "bold";
  }

  hideStepOneFromBeingActive() {
    this.isStepper2 = true;
    this.isProgress1 = false;
    this.isStepper1 = false; //Hide Tab 1
    this.background2 = "var(--sapphire)";
    const element = <HTMLElement>document.getElementsByClassName("step-one")[0];
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
  }

  hideStepTwoFromBeingActive() {
    this.isStepper3 = true;
    this.isProgress2 = true;
    this.background3 = "var(--sapphire)";
    const element = <HTMLElement>document.getElementsByClassName("step-two")[0];
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
  }

  hideStepThreeFromBeingActive() {
    this.background1 = "var(--sapphire)";
    this.background2 = "var(--background)";
    this.background3 = "var(--background)";

    this.isProgress1 = true;
    this.isProgress2 = false;
    this.isProgress3 = false;

    this.isStepper1 = true;
    this.isStepper2 = false;
    this.isStepper3 = false;
    const element = <HTMLElement>(
      document.getElementsByClassName("step-three")[0]
    );
    element.style.fontSize = "16px";
    element.style.fontWeight = "lighter";
  }

  // ------------Methods to Manage Stepper (END)-----------------//

    //Get Carrier Details
    getCarrierDetails() {
      this.isLoading = true;
      this._carrier.getCarrierById(this.currentPermitDetails.carrier_id).subscribe((res: any) => {
        this.carrierDetails = res;
      });
    }

    getAccountBalance(customerCode) {
      if (customerCode) {
        this._carrier.getUpdateBalance(customerCode).subscribe((res: any) => {
          this.accountBalance = -res.Result.AccountBalance;
        });
      }
    }


    // goNext(){
    //   this.StepperContainer.activeStepper.isProgress = 'false';
    //   this.StepperContainer.next();
    // }
    // prevStep(){
    //   this.StepperContainer.previous();
    // }

    getDetailsAndDocuments(index) {
      if (this.ids) {
        this.complianceIds = this.ids.split("_");
        this.currentId = this.complianceIds[index-1];
        this.getComplianceDetailsById();
        this.getComlianceDocumentsById();
      }
    }

     getIdFromUrl(url: string): string | null {
      const regex = /\/(\w+)$/; // Matches a word at the end of the URL
      const matches = regex.exec(url);
      if (matches && matches.length >= 2) {
        return matches[1];
      }
      return null; // ID not found or invalid URL
    }


    //DOCUMENTS
      //Get Documents using Input
  onChangeFile(event, type) {
    
    const files = [];
    let filesAmount = event.target.files.length;
    if (filesAmount > 10) {
      this.toastService.error(
        `Please select less than 10 files`,
        "Upload File"
      );
      return;
    }
    for (let findFile = 0; findFile < filesAmount; findFile++) {
      let allowedFileSize =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "MaxUploadMB1"
        );
      let maxAllowedSize = allowedFileSize.Value; //it is in MB
      let document_sizeMB = this.getFileSize(event.target.files[findFile]);
      if (maxAllowedSize <= document_sizeMB) {
        this.toastService.error(
          "Please select file of less than 5 MB",
          "Upload File"
        );
        return;
      }
      let typesOfFile = [];
      if (event.target.files[findFile].type !== "") {
        typesOfFile = this.getFileType(event.target.files[findFile]);
      }

      if (typesOfFile.length <= 0 || typesOfFile[1].toLowerCase() !== "pdf") {
        this.toastService.error(
          "Uploaded file is not a valid. PDF files are allowed",
          "UploadFile"
        );
        return;
      }

        // Convert the object to an array
  let DocsList = Object.values(this.allDocs);
      let fileFound = false;
      DocsList.forEach(
        function (value) {
          if (value[0].fileName.includes(event.target.files[0].name)) {
                fileFound = true;
            }
        }.bind(this)
    );

    if (fileFound) {
      this.toastService.error(
        `You already uploaded this file`,
        'File upload failed'
    );
        return;
    }

      this.saveSingleFile(event.target.files[0], type);
    }
  }

  async saveSingleFile(file, fileSaveId) {
    const formData: FormData = new FormData();

    formData.append(
      "FileName",
      `${this.currentPermitDetails.application_id} - ${this.currentPermitDetails.permit_id} - ${file.name}`
    );
    formData.append("TypeOfFile", this.getFileType(file).join("/").toString());
    formData.append("Notes", "upload");
    formData.append("FileSize", "" + file.size.toString());
    formData.append(
      "PermitID",
      this.currentPermitDetails.permit_id.toString()
    );
    formData.append(
      "PermitName",
      `PermitName - ${this.currentPermitDetails.permit_id} - ${file.name}`
    );
    formData.append("UserLastName", "");
    formData.append("documenttypeid", fileSaveId.toString());
    formData.append("ApplicationID", this.currentPermitDetails.application_id.toString());
    formData.append("VehicleID", "0"),
    formData.append("ComplianceDetailID", this.currentPermitDetails.id.toString());
    const filebytes = await this.readFile(file);
    formData.append("File", filebytes as any);
   
    return this.uploadFile(formData);
  }

  readFile(file) {
    return new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onerror = reject;
      fr.onload = () => {
        resolve(fr.result?.toString().split(",")[1]);
        fr.removeEventListener;
      };
      fr.readAsDataURL(file);
    });
  }

  uploadFile(formDataValue) {
    this.isLoading = true;
    this._document.postComplianceDocument(formDataValue).subscribe(
      (res) => {
        if (res) {
          this.isLoading = false;
          this.ShowAll = false;
          this.getComplianceDetailsById();
          this.getComlianceDocumentsById();
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  onPageChange(index) {
    this.pageNumber = index;
    this.currentId = this.complianceIds[index - 1];
    this.ShowAll = true;
    this.getComplianceDetailsById();
    this.getComlianceDocumentsById();
  }

  onConfirm(doc) {
    this.confirmDialogService.confirmThis(
      "Are you sure you want to delete? You're about to delete this document",
      () => {
        this.ShowAll = false;
        this.onDelete(doc);
      },
      () => {
        return;
      }
    );
  }

  onRemove(doc) {
    this.confirmDialogService.confirmThis(
      "Are you sure you want to remove? You're about to remove this document",
      () => {
        this.onDelete(doc);
      },
      () => {
        this.isChecked = true;
        return;
      }
    );
  }

  onDelete(doc: any) {
    this.isLoading = true;
    this.message = "Deleting selected document. Please wait...";
    this.documentService.deleteComplianceDocs(doc.id).subscribe(
      (result) => {
        this.toastService.success(
          `Document ${doc.fileName} deleted.`,
          "Delete Document"
        );
        this.isLoading = false;
        this.getComplianceDetailsById();
        this.getComlianceDocumentsById();
      },
      (error) => {
        this.isLoading = false;
        this.toastService.error(
          `Document ${this.removeRef.code} was not deleted.`,
          "Delete Document"
        );
      }
    );
  }

  OLDviewDoc(id, fileName) {
    id = fileName.substring(fileName.indexOf("#") + 1);
    this.pdfSrc = null;
    this.img = null;
    let ext = fileName.substring(fileName.length - 3, fileName.length);
    if (fileName.includes(".pdf")) {
      this.documentService.downloadpdf(id).subscribe((x) => {
        let objectURL = URL.createObjectURL(x);
        this.pdfSrc = objectURL;
      });
      return;
    }
    // this.documentService.download(id).subscribe((x) => {
    //   let objectURL = URL.createObjectURL(x);
    //   this.pdfSrc = null;
    //   this.img = this.sanitizer.bypassSecurityTrustUrl(objectURL);
    // });
  }

  viewDoc(file){
    console.log("Uploaded Docs", this.uploadedDocs)

    console.log("View Document",file)
    if(file!=undefined){
      this.isLoadingImg = true;
      this.pdfSrc = null;
     //TO DO:
      let id = file.shareId ?? file.document_link.substring(file.document_link.indexOf('#')+1);
      console.log("Document Id",id)
      if(file.document_link.includes('.pdf')){
        this.documentService.downloadpdf(id).subscribe(x => {
          let objectURL = URL.createObjectURL(x);
          this.pdfSrc = objectURL;

          this.isLoadingImg = false;
        })
        return
      }
      this.documentService.download(id).subscribe(x => {
        let objectURL = URL.createObjectURL(x);
        this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        this.isLoadingImg = false;
      })
    }
  }

  onUseDocumentCheck(event, id, docs) {
    let body: any = {};
    if (event.target.checked) {
      docs.forEach((document) => {
        if (document.document_type_id === id) {
          body.document_type_id = id;
          body.id = document.id;
          body.carrier_id = this.currentPermitDetails.carrier_id;
          body.is_upload = 1;
          body.is_permit = 0;
          body.compliance_annual_id = 1;
          body.is_compliance = 1;
        }
      });
      for (const key in this.allDocs) {
        if (key == id) {
          // this.allDocs.map(({document_link, fileName}) => (console.log(document_link, fileName)));
          this.allDocs[key].forEach((document) => {
            body.document_link = document.document_link;
            body.file_name = document.fileName;
            this.documentPayload.push(body);
          });
        }
      }
    } else {
      this.documentPayload.forEach((document) => {
        if (id == document.document_type_id) {
          this.documentPayload.splice(document, 1);
        }
      });
    }
  }

  onUseDocumentCheckNew(event, doc) {
    let body: any = {};
    if (!event.target.checked) {
        this.onRemove(doc);
    }
  }


  getFileName(file: File) {
    return file.name;
  }

  getFileType(file: File) {
    const typesOfFile = file.type.split("/");
    return typesOfFile;
  }

  getFileSize(file: File) {

    return file.size / 1000000;
  }

  nextStep(){
    this.nextStepEmitter.emit(0)
  }

  prevStep(){
    this.prevStepEmitter.emit(0)
  }

  getPermitDetailsByIdPayment() {
    this.isLoading = true;
    this._permit.getById(this.currentId).subscribe(
      (res: any) => {
        if (res) {
          this.getAccountBalance(res.carrier_account_id);
          this.carrierId = res.carrier_id;
        }
        this.isLoading = false;

      },
      (err) => {
        this.isLoading = false;
        console.error(err);
      }
    );
  }



  async  getComplianceDetailsForDocumentss(): Promise<void> {

    this.isLoading = true;
    this._annualCompliance.getAnnualComplianceDetailsById(this.currentId).subscribe(
      (res: any) => {
        if (res) {
          this.currentPermitDetails = res;
          this.carrierId = res.carrier_id;
          this.getPermitRelatedDocsByID();
          
        }
        this.isLoading = false;

      },
      (err) => {
        this.isLoading = false;
        console.error(err);
      }
    );
  }

  async getComplianceDetailsForDocuments(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.isLoading = true;
      this._annualCompliance.getAnnualComplianceDetailsById(this.currentId).subscribe(
        (res: any) => {
          if (res) {
            this.currentPermitDetails = res;
            this.carrierId = res.carrier_id;
            this.getPermitRelatedDocsByID();
          }
          this.isLoading = false;
          resolve(); // Resolve the promise when the operation is complete
        },
        (error: any) => {
          this.isLoading = false;
          console.error(error);
          reject(error); // Reject the promise if there is an error
        }
      );
    });
  }

  getComlianceDocumentsById() {
    this.isLoading = true;

    if(this.ShowAll == true){
      this._document.getComplianceDocsById(this.currentPermitDetails.id ,this.currentPermitDetails.permit_id ,this.currentPermitDetails.permit_type_id)
      .subscribe((res: any) => {
        if (res) {
          this.uploadedDocs = res;
          this.patchDocs();
        }
      });
    }
    else{
      this._document.getComplianceDocsByIdUploaded(this.currentPermitDetails.id)
      .subscribe((res: any) => {
        if (res) {
          this.uploadedDocs = res;
          this.patchDocs();
        }
      });

    }

  }
  
  
}
